const getCookie = (name: string): string | null => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);

  if (parts && parts.length === 2) {
    const last = parts.pop();
    return last ? last.split(';').shift() || null : null;
  }

  return null;
};

const parseCookie = (cookie?: string) =>
  cookie ? JSON.parse(window.atob(cookie)) : null;

const loadCookie = <T = Record<string, unknown>>(name: string): T | null => {
  const rawCookie = getCookie(name);
  if (!rawCookie) {
    return null;
  }
  return parseCookie(rawCookie);
};

export default loadCookie;
